<div *ngIf="!user" class="log-in">
	<button *ngIf="!user" (click)="startLogin()" class="log-in-btn">Log In</button>
</div>
<div *ngIf="user">
	<ul>
		<li class="menu-item" (click)="navigateTo('profile')">
			<mat-icon aria-hidden="false" aria-label="Person icon">person</mat-icon>
			<div class="text">My Profile</div>
		</li>
		<li class="menu-item" (click)="navigateTo('team/list')">
			<mat-icon aria-hidden="false" aria-label="Group icon">groups</mat-icon>
			<div class="text">MyTeams</div>
		</li>
		<li class="menu-item" (click)="logout()">
			<mat-icon aria-hidden="false" aria-label="Logout icon">logout</mat-icon>
			<div class="text">Logout</div>
		</li>
	</ul>
</div>
<div *ngIf="loggingOut" class="overlay">
	<h1>Logging out...</h1>
</div>